/* global _ */
import {name} from './config'
import MainMixin from './mixins'
const mixins = [MainMixin]

export default {
  name,
  mixins
}
